var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSchool5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 1080,
    viewBox: "0 0 1920 1080",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_753_15)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M712 8L712 36",
    stroke: "#F2DCCE",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 712.5,
    cy: 3.33333,
    rx: 16.5,
    ry: 16.3333,
    fill: "#F2DCCE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M712 12L705 8.2V2.2L701 -3.57628e-07L712 -6L723 -3.57628e-07V8H721V1.1L719 2.2V8.2L712 12ZM712 3.7L718.85 -3.57628e-07L712 -3.7L705.15 -3.57628e-07L712 3.7ZM712 9.725L717 7.025V3.25L712 6L707 3.25V7.025L712 9.725Z",
    fill: "#CC7D61"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_753_15"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 1080,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSchool5);
export default __webpack_public_path__ + "static/media/school_5.0aebe573607db202a4d1a67753d47a57.svg";
export { ForwardRef as ReactComponent };